import { BaseNetworkLog } from './base-network-log';
import { NetworkLogStatus } from '../types';
import type { NetworkRequestData, NetworkResponseData } from '../types';
import type { PendingNetworkLog } from './pending-network-log';

export class DoneNetworkLog extends BaseNetworkLog {
  public status = NetworkLogStatus.DONE as const;

  public request: NetworkRequestData;

  public response: NetworkResponseData;

  constructor(
    pendingNetworkLog: PendingNetworkLog,
    responseData: NetworkResponseData,
  ) {
    super(pendingNetworkLog.id);
    this.request = pendingNetworkLog.request;
    this.response = responseData;
  }
}
